module.exports = __webpack_public_path__ + "97f3c47482c06ee5c32d1bfb38042873.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-0.png
// module id = 1724
// module chunks = 0